import { HttpResCode } from "@be/constants/http-res-code";
import type { Clerk } from "@clerk/shared/types";

declare global {
	interface Window {
		Clerk: Clerk;
	}
}

export const authenticatedFetch = async (
	input: RequestInfo | URL,
	init?: RequestInit,
) => {
	const token = await window.Clerk.session?.getToken();

	const headers = new Headers(init?.headers);

	headers.set("Authorization", `Bearer ${token}`);

	const res = await fetch(input, {
		...init,
		headers,
	});

	if (res.status === HttpResCode.PAYMENT_REQUIRED) {
		window.location.assign("/");
	}

	return res;
};
